interface ValidationSummaryCardItem {
  label: string;
  value: number;
  tone: 'success' | 'destructive' | 'warning' | 'neutral';
  testId?: string;
}

interface ValidationSummaryCardsProps {
  items: ValidationSummaryCardItem[];
}

const TONE_CLASSES: Record<ValidationSummaryCardItem['tone'], string> = {
  success: 'border-emerald-200 bg-emerald-50/70 text-emerald-800',
  destructive: 'border-red-200 bg-red-50/70 text-red-800',
  warning: 'border-amber-200 bg-amber-50/70 text-amber-800',
  neutral: 'border-border bg-muted/20 text-foreground',
};

export function ValidationSummaryCards({ items }: ValidationSummaryCardsProps) {
  return (
    <div
      className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4"
      data-testid="validation-summary-cards"
    >
      {items.map((item) => (
        <div
          key={item.label}
          className={`rounded-lg border px-4 py-3 ${TONE_CLASSES[item.tone]}`}
          data-testid={item.testId}
        >
          <p className="text-xs text-current/80">{item.label}</p>
          <p className="mt-1 text-2xl font-semibold leading-none">{item.value}</p>
        </div>
      ))}
    </div>
  );
}
